import styled from 'styled-components';

export const Container = styled.div`
    margin-left: 0.7rem;
    font-size: 0.8rem;

    .openButtonState{
        color: #535354;
        margin-left: 0.5rem;
        transform: ${props => props.openState ? 'rotate(180deg)' : 'none'};
        transition: transform .25s;
    }
    
    .cleanStateButton{
        opacity: 0;
        transition: opacity 0.15s;
    }

    .text{
        &:hover {
            .cleanStateButton{
                opacity: 1;
            }
        }
    }

    svg{
        font-size: 1rem;
    }
`
